import {createContext, use} from 'react'

import type {AhpDebugEvent} from '../utils/ahp-debug-log'

export const DebugEventsDataContext = createContext<AhpDebugEvent[] | null>(null)
export const DebugEventsAppendContext = createContext<((event: AhpDebugEvent) => void) | null>(null)

export type DebugEventsGetter = () => readonly AhpDebugEvent[]

/**
 * Reads the captured log on demand. Kept separate from
 * `DebugEventsDataContext` so that consumers which only need the log when the
 * user acts do not re-render on every captured transport frame.
 */
export const DebugEventsGetterContext = createContext<DebugEventsGetter | null>(null)

const NO_DEBUG_EVENTS: readonly AhpDebugEvent[] = []
const getNoDebugEvents: DebugEventsGetter = () => NO_DEBUG_EVENTS

/**
 * Returns a stable getter for the captured AHP transport log. Outside a
 * provider it yields an empty list, so surfaces that never capture the log can
 * still offer log-backed actions without crashing.
 */
export function useOptionalDebugEventsGetter(): DebugEventsGetter {
  return use(DebugEventsGetterContext) ?? getNoDebugEvents
}
